export default __webpack_public_path__ + "static/media/pic8.c70a71cb.jpg";